import React from 'react';
import Lightbox from 'react-image-lightbox';
import NPPanel from '../NPPanel/index';
import 'react-image-lightbox/style.css';
import LoadingSpinner from '../LoadingSpinner/index'
import ApiHelper from '../util/api.helper'

export default class NPLightbox extends React.Component{

    constructor(props)
    {
        super(props);

        this.onClose = props.onClose;
        this.image = props.image;
        this.imageEndpoint = props.endpoint;

        this.state = {
            image: this.props.image,
            header: this.props.header,
            isLoading: true,

        }
    }

    componentDidMount() {
        ApiHelper.getFromPost(this.state.header, this.imageEndpoint, this.state.image)
        .then((res) => {
            if(res != null)
            {
                this.setState({data: `data:image/png;base64,${res}`})
            }
            else{
                this.onClose();
            }
        })
    }

    render() {
        //Use this to overlay the header
        const modalStyles = {
            overlay: {
                zIndex: 1000001
            }
        }

        return (
            <Lightbox
                mainSrc={this.state.data}
                onCloseRequest={this.onClose}
                imagePadding={200}
                enableZoom={false}
                closeLabel="Close"
                reactModalStyle={modalStyles}
            />
        )
    }
}

//ONimageloaderror
//onimageload